"use client";
import s from "./AllArticlesSection.module.scss";
import st from "@/components/pages/blog/ai-article/common.module.scss";
import { StrapiArticleCondensedResponse } from "@/shared/types/strapi/collections/article";
import { Link } from "./Link";
import cn from "classnames";
import React, { useMemo, useState } from "react";
import { Container } from "@/components/layout/Container";
import { InputSearch } from "@/components/pages/blog/ai-article/components/InputSearch";
import { highlight } from "@/helpers/highlight";

export type AllArticlesSectionProps = {
  articles: StrapiArticleCondensedResponse;
  categorySlug: string;
};

export const AllArticlesSection = ({ articles, categorySlug }: AllArticlesSectionProps) => {
  const [searchTerm, setSearchTerm] = useState("");
  const list = articles.data.sort(
    (a, b) => (a.attributes.displayOrder || 0) - (b.attributes.displayOrder || 0)
  );

  const filteredItems = useMemo(
    () =>
      list.filter(({ attributes }: any) => {
        return !!attributes.heading.toLowerCase().match(
          searchTerm
            .trim()
            .replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&")
            .toLowerCase()
        );
      }),
    [list, searchTerm]
  );

  const handleSearch = (value = "") => {
    setSearchTerm(value);
  };

  const isNotFound = searchTerm.length > 3 && !filteredItems.length;
  const isSearching = searchTerm.length > 3 && !!filteredItems.length;

  const count = filteredItems.length || list.length;

  return (
    <div className={s.section}>
      <Container className={s.container}>
        <h2 className={cn(st.h2, s.heading)}>Category related articles</h2>
        <div className={s.searchInputWrap}>
          <InputSearch
            placeholder="Search"
            searchTerm={searchTerm}
            handleSearch={handleSearch}
            className={s.searchInput}
            number={count}
          />
        </div>
        {isNotFound ? (
          <div className={cn(st.fBig, s.notFound)}>
            Sorry, we couldn&apos;t find any results for <strong>{searchTerm}</strong>.<br />
            Please try a different query instead.
          </div>
        ) : (
          <ul className={s.articlesList}>
            {(isSearching ? filteredItems : list).map((item) => (
              <li key={item.id}>
                <Link
                  href={`/${categorySlug}/${item.attributes.slug}`}
                  className={st.fBig}
                  dangerouslySetInnerHTML={{
                    __html: highlight(item.attributes.heading, searchTerm, s.resultHighlighted),
                  }}
                />
              </li>
            ))}
          </ul>
        )}
      </Container>
    </div>
  );
};
